import * as React from 'react';

import { SocialBarIcon } from './SocialBarIcon';
import { st, classes } from './SocialBar.st.css';
import { useTPAComponentsContext } from '../TPAComponentsConfig';
import { SocialBarProps } from './types';
import { SocialBarThemes } from './consts';
import { SocialBarProvider } from './SocialBarContext';

export const SocialBar = ({
  theme = SocialBarThemes.light,
  children,
  className,
  'data-hook': dataHook,
}: SocialBarProps) => {
  const { mobile } = useTPAComponentsContext();

  return (
    <SocialBarProvider value={theme}>
      <ul
        className={st(classes.root, { mobile }, className)}
        data-hook={dataHook}
      >
        {children}
      </ul>
    </SocialBarProvider>
  );
};

SocialBar.Icon = SocialBarIcon;
